import { TicketPage } from "~/pages/tickets/ticket/TicketPage";
import { Space } from "~/lib/types";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";

type Props = {
  space: Space;
  scope: SpaceOrWorkspaceScope;
};

const TicketEntryPage = ({ scope, space }: Props) => {
  return <TicketPage space={space} scope={scope} />;
};

export default TicketEntryPage;
